/**
 * Mode-aware role key used for catalog queries and post-login routing.
 * Permission checks (edit, delete, superadmin) live in `src/utils/roleUtils.js`
 * because they follow the stored account role, not the current reader/writer mode.
 */
export const ROLE = Object.freeze({
  PUBLIC: "public",
  READER: "reader",
  WRITER: "writer",
  SUPERADMIN: "superadmin",
});

export const resolveRoleKey = (user) => {
  if (!user) return ROLE.PUBLIC;

  const legacyRole = String(user.role || "").toLowerCase();
  if (legacyRole === ROLE.SUPERADMIN || legacyRole === "admin") return ROLE.SUPERADMIN;

  const mode = String(user.currentMode || legacyRole || ROLE.READER).toLowerCase();
  return mode === ROLE.WRITER ? ROLE.WRITER : ROLE.READER;
};

export const getDashboardRouteByRole = (roleKey) =>
  roleKey === ROLE.SUPERADMIN ? "/admin/dashboard" : "/app/dashboard";
